export const QUESTION_DB = [

    // =================================================================
    // EASY QUESTIONS (ID 1-50)
    // Focus: Basic SELECT, WHERE, ORDER BY, LIMIT, Simple Aggregates
    // =================================================================
    { 
      id: 1, 
      difficulty: 'Easy', 
      query: 'SELECT * FROM Users WHERE age > 18', 
      question: 'This query retrieves all columns for users older than 18. What is the primary role of the WHERE clause here?', 
      options: ['To sort the results', 'To filter rows based on a condition', 'To group data', 'To join tables'], 
      answer: 'To filter rows based on a condition', 
      explanation: 'The WHERE clause is used to extract only those records that fulfill a specified condition.' 
    },
    { 
      id: 2, 
      difficulty: 'Easy', 
      query: 'SELECT name, email FROM Users ORDER BY name', 
      question: 'You are selecting specific columns and sorting them. By default, how does ORDER BY sort data?', 
      options: ['Descending (Z-A)', 'Ascending (A-Z)', 'Randomly', 'By Date'], 
      answer: 'Ascending (A-Z)', 
      explanation: 'ORDER BY sorts records in ascending order by default. Use DESC to sort in descending order.' 
    },
    { 
      id: 3, 
      difficulty: 'Easy', 
      query: 'SELECT DISTINCT country FROM Customers LIMIT 5', 
      question: 'This query combines DISTINCT and LIMIT. What will be the result?', 
      options: ['5 random rows', 'The first 5 unique countries', '5 duplicate countries', 'The last 5 countries'], 
      answer: 'The first 5 unique countries', 
      explanation: 'DISTINCT removes duplicates first, and then LIMIT restricts the output to the top 5 results.' 
    },
    { 
      id: 4, 
      difficulty: 'Easy', 
      query: 'SELECT COUNT(*) FROM Orders WHERE status = "Shipped"', 
      question: 'This query calculates a total. What exactly is being counted?', 
      options: ['The total price of orders', 'The number of shipped orders', 'The number of customers', 'The average shipping time'], 
      answer: 'The number of shipped orders', 
      explanation: 'COUNT(*) returns the number of rows that match the WHERE condition.' 
    },
    { 
      id: 5, 
      difficulty: 'Easy', 
      query: 'SELECT * FROM Products WHERE price BETWEEN 10 AND 50', 
      question: 'The BETWEEN operator is used here. Are the values 10 and 50 included in the result?', 
      options: ['No, strictly between', 'Yes, it is inclusive', 'Only 10 is included', 'Only 50 is included'], 
      answer: 'Yes, it is inclusive', 
      explanation: 'The BETWEEN operator selects values within a given range and includes the start and end values.' 
    },
    {
      id: 6,
      difficulty: 'Easy',
      query: 'SELECT * FROM Employees WHERE dept_id IS NULL',
      question: 'What does IS NULL check for?',
      options: ['Zero values', 'Empty strings', 'Missing or undefined values', 'False values'],
      answer: 'Missing or undefined values',
      explanation: 'NULL represents missing or undefined data. IS NULL checks if a column contains this value.'
    },
    {
      id: 7,
      difficulty: 'Easy',
      query: 'SELECT first_name, last_name FROM Users',
      question: 'What does this query return?',
      options: ['All columns for Users', 'Only the first and last name columns', 'The number of users', 'Users sorted by name'],
      answer: 'Only the first and last name columns',
      explanation: 'Specifying column names in the SELECT clause retrieves only those specific columns.'
    },
    {
      id: 8,
      difficulty: 'Easy',
      query: 'SELECT * FROM Orders ORDER BY date DESC',
      question: 'How will the results be ordered?',
      options: ['Oldest dates first', 'Newest dates first', 'Alphabetically', 'Randomly'],
      answer: 'Newest dates first',
      explanation: 'DESC stands for Descending. For dates, this means from latest (newest) to earliest (oldest).'
    },
    {
      id: 9,
      difficulty: 'Easy',
      query: 'SELECT MIN(price) FROM Products',
      question: 'What value does this query return?',
      options: ['The lowest price', 'The highest price', 'The average price', 'The sum of all prices'],
      answer: 'The lowest price',
      explanation: 'The MIN() aggregate function returns the smallest value in the selected column.'
    },
    {
      id: 10,
      difficulty: 'Easy',
      query: 'SELECT MAX(salary) FROM Employees',
      question: 'What value does this query return?',
      options: ['The lowest salary', 'The highest salary', 'The total salary', 'The number of salaries'],
      answer: 'The highest salary',
      explanation: 'The MAX() aggregate function returns the largest value in the selected column.'
    },
    {
      id: 11,
      difficulty: 'Easy',
      query: 'SELECT AVG(score) FROM Exams',
      question: 'What does AVG() calculate?',
      options: ['The total score', 'The mean score', 'The median score', 'The lowest score'],
      answer: 'The mean score',
      explanation: 'AVG() calculates the arithmetic mean (average) of a numeric column.'
    },
    {
      id: 12,
      difficulty: 'Easy',
      query: 'SELECT SUM(quantity) FROM Sales',
      question: 'What does SUM() do?',
      options: ['Counts the rows', 'Adds up all values in the column', 'Finds the largest value', 'Averages the values'],
      answer: 'Adds up all values in the column',
      explanation: 'SUM() returns the total sum of a numeric column.'
    },
    {
      id: 13,
      difficulty: 'Easy',
      query: 'SELECT * FROM Users WHERE name LIKE "A%"',
      question: 'What does the % wildcard represent?',
      options: ['Exactly one character', 'Zero or more characters', 'A number', 'A space'],
      answer: 'Zero or more characters',
      explanation: 'The % wildcard matches any sequence of characters (including zero characters).'
    },
    {
      id: 14,
      difficulty: 'Easy',
      query: 'SELECT * FROM Users WHERE name LIKE "_a%"',
      question: 'What does the _ wildcard represent?',
      options: ['Any string', 'Exactly one single character', 'A digit', 'Whitespace'],
      answer: 'Exactly one single character',
      explanation: 'The underscore (_) matches exactly one single character in a pattern.'
    },
    {
      id: 15,
      difficulty: 'Easy',
      query: 'SELECT * FROM Products WHERE price NOT BETWEEN 10 AND 20',
      question: 'Which prices would be returned?',
      options: ['10, 15, 20', '5, 25', '10, 20', '15 only'],
      answer: '5, 25',
      explanation: 'NOT BETWEEN selects values outside the specified range.'
    },
    {
      id: 16,
      difficulty: 'Easy',
      query: 'SELECT * FROM Customers WHERE city IN ("Paris", "London")',
      question: 'What does the IN operator do here?',
      options: ['Matches any city starting with Paris', 'Matches if city is Paris OR London', 'Matches if city is Paris AND London', 'Matches cities between Paris and London'],
      answer: 'Matches if city is Paris OR London',
      explanation: 'IN allows you to specify multiple values in a WHERE clause, acting like multiple OR conditions.'
    },
    {
      id: 17,
      difficulty: 'Easy',
      query: 'SELECT * FROM Users LIMIT 10 OFFSET 5',
      question: 'Which rows will be returned?',
      options: ['Rows 1-10', 'Rows 5-15', 'Rows 6-15', 'Rows 1-5'],
      answer: 'Rows 6-15',
      explanation: 'OFFSET 5 skips the first 5 rows, and LIMIT 10 takes the next 10.'
    },
    {
      id: 18,
      difficulty: 'Easy',
      query: 'SELECT 10 + 20 AS Total',
      question: 'What is "Total" in this query?',
      options: ['A column name from a table', 'An alias for the calculation result', 'A variable', 'A function'],
      answer: 'An alias for the calculation result',
      explanation: 'AS creates a temporary name (alias) for a column or table.'
    },
    {
      id: 19,
      difficulty: 'Easy',
      query: 'SELECT UPPER(name) FROM Users',
      question: 'What does the UPPER() function do?',
      options: ['Sorts names alphabetically', 'Converts text to uppercase', 'Capitalizes the first letter', 'Finds the longest name'],
      answer: 'Converts text to uppercase',
      explanation: 'UPPER() converts all characters in a string to uppercase.'
    },
    {
      id: 20,
      difficulty: 'Easy',
      query: 'SELECT LOWER(email) FROM Users',
      question: 'Why might you use LOWER() on emails?',
      options: ['To encrypt them', 'To ensure consistent formatting for comparison', 'To delete them', 'To validate the domain'],
      answer: 'To ensure consistent formatting for comparison',
      explanation: 'LOWER() converts text to lowercase, useful for case-insensitive comparisons.'
    },
    {
      id: 21,
      difficulty: 'Easy',
      query: 'SELECT LENGTH(password) FROM Users',
      question: 'What does LENGTH() return?',
      options: ['The complexity of the password', 'The number of characters in the string', 'The memory size in bytes', 'The first letter'],
      answer: 'The number of characters in the string',
      explanation: 'LENGTH() returns the count of characters in a string.'
    },
    {
      id: 22,
      difficulty: 'Easy',
      query: 'SELECT * FROM Orders WHERE order_date = CURRENT_DATE',
      question: 'What does CURRENT_DATE represent?',
      options: ['The date the order was made', 'Tomorrow\'s date', 'Today\'s system date', 'January 1st'],
      answer: 'Today\'s system date',
      explanation: 'CURRENT_DATE returns the current date from the database system.'
    },
    {
      id: 23,
      difficulty: 'Easy',
      query: 'SELECT CONCAT(first_name, " ", last_name) FROM Users',
      question: 'What is the result of CONCAT?',
      options: ['Two separate columns', 'One combined string column', 'A list of names', 'A calculation'],
      answer: 'One combined string column',
      explanation: 'CONCAT joins two or more strings together into one.'
    },
    {
      id: 24,
      difficulty: 'Easy',
      query: 'SELECT ABS(-50)',
      question: 'What does ABS() calculate?',
      options: ['The average', 'The absolute (positive) value', 'The square root', 'The negative value'],
      answer: 'The absolute (positive) value',
      explanation: 'ABS() returns the absolute value of a number (removing the negative sign).'
    },
    {
      id: 25,
      difficulty: 'Easy',
      query: 'SELECT ROUND(12.56, 1)',
      question: 'What will be the result?',
      options: ['12', '12.5', '12.6', '13'],
      answer: '12.6',
      explanation: 'ROUND(x, d) rounds the number x to d decimal places.'
    },
    {
      id: 26,
      difficulty: 'Easy',
      query: 'SELECT * FROM Products WHERE price > 100 AND stock > 0',
      question: 'When does this return a row?',
      options: ['If price > 100 OR stock > 0', 'Only if BOTH conditions are true', 'If price > 100 but stock is 0', 'Never'],
      answer: 'Only if BOTH conditions are true',
      explanation: 'The AND operator requires all conditions to be true for the record to be selected.'
    },
    {
      id: 27,
      difficulty: 'Easy',
      query: 'SELECT * FROM Products WHERE category = "Toys" OR category = "Games"',
      question: 'When does this return a row?',
      options: ['Only if it is BOTH Toys and Games', 'If it is EITHER Toys OR Games', 'Only if it is Toys', 'Never'],
      answer: 'If it is EITHER Toys OR Games',
      explanation: 'The OR operator requires at least one of the conditions to be true.'
    },
    {
      id: 28,
      difficulty: 'Easy',
      query: 'SELECT DISTINCT category, subcategory FROM Products',
      question: 'What makes a row "distinct" here?',
      options: ['Only unique categories', 'Only unique subcategories', 'Unique combinations of category AND subcategory', 'Random rows'],
      answer: 'Unique combinations of category AND subcategory',
      explanation: 'DISTINCT with multiple columns returns unique combinations of those columns.'
    },
    {
      id: 29,
      difficulty: 'Easy',
      query: 'DELETE FROM Cart WHERE user_id = 5',
      question: 'What does this query do?',
      options: ['Deletes the user', 'Removes rows from Cart for user 5', 'Deletes the table Cart', 'Updates user 5'],
      answer: 'Removes rows from Cart for user 5',
      explanation: 'DELETE removes records from a table based on the WHERE condition.'
    },
    {
      id: 30,
      difficulty: 'Easy',
      query: 'UPDATE Users SET active = 1 WHERE id = 10',
      question: 'What is modified here?',
      options: ['A new row is added', 'The active column for user 10', 'All active columns', 'The user ID'],
      answer: 'The active column for user 10',
      explanation: 'UPDATE modifies existing records. SET specifies the new value.'
    },
    {
      id: 31,
      difficulty: 'Easy',
      query: 'INSERT INTO Logs (message) VALUES ("Error")',
      question: 'What does INSERT INTO do?',
      options: ['Updates an existing row', 'Adds a new row to the table', 'Creates a new table', 'Deletes a log'],
      answer: 'Adds a new row to the table',
      explanation: 'INSERT INTO is used to add new records to a database table.'
    },
    {
      id: 32,
      difficulty: 'Easy',
      query: 'SELECT * FROM Users WHERE age <> 18',
      question: 'What does the <> operator mean?',
      options: ['Less than', 'Greater than', 'Not equal to', 'Approximately equal'],
      answer: 'Not equal to',
      explanation: 'The <> operator (and !=) checks for inequality.'
    },
    {
      id: 33,
      difficulty: 'Easy',
      query: 'SELECT * FROM Books WHERE title LIKE "%Guide%"',
      question: 'Which title would match?',
      options: ['"Guide to SQL"', '"A User Guide"', '"The Guide"', 'All of the above'],
      answer: 'All of the above',
      explanation: '% match any string, so "%Guide%" matches "Guide" anywhere in the title.'
    },
    {
      id: 34,
      difficulty: 'Easy',
      query: 'SELECT CEIL(4.2)',
      question: 'What does CEIL return?',
      options: ['4', '4.2', '5', '4.5'],
      answer: '5',
      explanation: 'CEIL() returns the smallest integer greater than or equal to the number (rounds up).'
    },
    {
      id: 35,
      difficulty: 'Easy',
      query: 'SELECT FLOOR(4.8)',
      question: 'What does FLOOR return?',
      options: ['4', '4.8', '5', '4.5'],
      answer: '4',
      explanation: 'FLOOR() returns the largest integer less than or equal to the number (rounds down).'
    },
    {
      id: 36,
      difficulty: 'Easy',
      query: 'SELECT 10 % 3',
      question: 'What is the result of the modulo operator %?',
      options: ['3', '1', '3.33', '0'],
      answer: '1',
      explanation: 'Modulo (%) returns the remainder of a division operation (10 / 3 = 3 remainder 1).'
    },
    {
      id: 37,
      difficulty: 'Easy',
      query: 'SELECT * FROM Users WHERE NOT active = 1',
      question: 'Which users are selected?',
      options: ['Active users', 'Inactive users (active != 1)', 'Users with ID 1', 'No users'],
      answer: 'Inactive users (active != 1)',
      explanation: 'NOT negates the condition following it.'
    },
    {
      id: 38,
      difficulty: 'Easy',
      query: 'SELECT NOW()',
      question: 'What information does NOW() typically provide?',
      options: ['Date only', 'Time only', 'Date and Time', 'Timezone only'],
      answer: 'Date and Time',
      explanation: 'NOW() returns the current date and time stamp.'
    },
    {
      id: 39,
      difficulty: 'Easy',
      query: 'SELECT SQRT(64)',
      question: 'What does SQRT calculate?',
      options: ['Square', 'Square Root', 'Cube Root', 'Logarithm'],
      answer: 'Square Root',
      explanation: 'SQRT() calculates the square root of a non-negative number.'
    },
    {
      id: 40,
      difficulty: 'Easy',
      query: 'SELECT REPLACE("Hello World", "World", "SQL")',
      question: 'What is the result string?',
      options: ['"Hello World"', '"Hello SQL"', '"SQL World"', '"Hello"'],
      answer: '"Hello SQL"',
      explanation: 'REPLACE(str, from, to) replaces all occurrences of "from" with "to" in "str".'
    },
    {
      id: 41,
      difficulty: 'Easy',
      query: 'SELECT LEFT("Database", 4)',
      question: 'What does LEFT return?',
      options: ['"Data"', '"base"', '"D"', '"ase"'],
      answer: '"Data"',
      explanation: 'LEFT(str, len) returns the specified number of characters from the left side of a string.'
    },
    {
      id: 42,
      difficulty: 'Easy',
      query: 'SELECT RIGHT("Database", 4)',
      question: 'What does RIGHT return?',
      options: ['"Data"', '"base"', '"D"', '"ase"'],
      answer: '"base"',
      explanation: 'RIGHT(str, len) returns the specified number of characters from the right side of a string.'
    },
    {
      id: 43,
      difficulty: 'Easy',
      query: 'SELECT POWER(2, 3)',
      question: 'What is the result of 2 to the power of 3?',
      options: ['6', '5', '8', '9'],
      answer: '8',
      explanation: 'POWER(x, y) returns x raised to the power of y (2^3 = 8).'
    },
    {
      id: 44,
      difficulty: 'Easy',
      query: 'SELECT * FROM Users WHERE age >= 21',
      question: 'Is a 21-year-old user included?',
      options: ['Yes', 'No', 'Depends on database', 'Only if active'],
      answer: 'Yes',
      explanation: '>= means "Greater than or Equal to", so 21 is included.'
    },
    {
      id: 45,
      difficulty: 'Easy',
      query: 'SELECT * FROM Users WHERE age <= 21',
      question: 'Is a 22-year-old user included?',
      options: ['Yes', 'No', 'Depends on database', 'Only if active'],
      answer: 'No',
      explanation: '<= means "Less than or Equal to", so 22 is excluded.'
    },
    {
      id: 46,
      difficulty: 'Easy',
      query: 'SELECT COALESCE(NULL, "Default")',
      question: 'What does COALESCE return here?',
      options: ['NULL', '"Default"', 'Error', 'Empty string'],
      answer: '"Default"',
      explanation: 'COALESCE returns the first non-null value in the list.'
    },
    {
      id: 47,
      difficulty: 'Easy',
      query: 'SELECT TRIM("  SQL  ")',
      question: 'What is the result?',
      options: ['"  SQL  "', '"SQL  "', '"  SQL"', '"SQL"'],
      answer: '"SQL"',
      explanation: 'TRIM removes leading and trailing whitespace.'
    },
    {
      id: 48,
      difficulty: 'Easy',
      query: 'SELECT NULLIF(10, 10)',
      question: 'What does NULLIF return if values are equal?',
      options: ['10', 'NULL', 'TRUE', 'FALSE'],
      answer: 'NULL',
      explanation: 'NULLIF(a, b) returns NULL if a = b; otherwise it returns a.'
    },
    {
      id: 49,
      difficulty: 'Easy',
      query: 'SELECT * FROM Users LIMIT 1',
      question: 'How many rows max will be returned?',
      options: ['0', '1', '10', 'All'],
      answer: '1',
      explanation: 'LIMIT 1 restricts the output to a single row.'
    },
    {
      id: 50,
      difficulty: 'Easy',
      query: 'SELECT 5 * 10 AS Area',
      question: 'What operation is performed?',
      options: ['Addition', 'Division', 'Multiplication', 'Exponentiation'],
      answer: 'Multiplication',
      explanation: '* is the multiplication operator in SQL.'
    },

  /// =================================================================
  // MEDIUM QUESTIONS (ID 101-150)
  // Focus: JOINS, GROUP BY, HAVING, Subqueries, Constraints, Functions
  // =================================================================
  { 
    id: 101, 
    difficulty: 'Medium', 
    query: 'SELECT Users.name, Orders.id FROM Users JOIN Orders ON Users.id = Orders.user_id', 
    question: 'This is an INNER JOIN. What happens to Users who have NO orders?', 
    options: ['They are included with NULL order IDs', 'They are excluded from the results', 'They are duplicated', 'The query throws an error'], 
    answer: 'They are excluded from the results', 
    explanation: 'INNER JOIN selects records that have matching values in both tables. Users without orders are not matched.' 
  },
  { 
    id: 102, 
    difficulty: 'Medium', 
    query: 'SELECT category, AVG(price) FROM Products GROUP BY category', 
    question: 'You are aggregating data. Why is GROUP BY necessary here?', 
    options: ['To sort the categories', 'To calculate the average for each category independently', 'To remove duplicate prices', 'It is optional'], 
    answer: 'To calculate the average for each category independently', 
    explanation: 'The GROUP BY statement groups rows that have the same values into summary rows, often used with aggregate functions like AVG.' 
  },
  { 
    id: 103, 
    difficulty: 'Medium', 
    query: 'SELECT * FROM Employees WHERE department_id IN (1, 2, 5)', 
    question: 'The IN operator is used. How could this be rewritten using OR?', 
    options: ['id=1 AND id=2 AND id=5', 'id=1 OR id=2 OR id=5', 'id BETWEEN 1 AND 5', 'id LIKE "1,2,5"'], 
    answer: 'id=1 OR id=2 OR id=5', 
    explanation: 'The IN operator is a shorthand for multiple OR conditions.' 
  },
  { 
    id: 104, 
    difficulty: 'Medium', 
    query: 'SELECT name FROM Students WHERE name LIKE "_a%"', 
    question: 'This wildcard pattern is specific. What names would this match?', 
    options: ['Names starting with "a"', 'Names ending with "a"', 'Names where the second letter is "a"', 'Any name containing "a"'], 
    answer: 'Names where the second letter is "a"', 
    explanation: 'The underscore (_) matches exactly one character, so "_a%" means any character followed by "a", then anything else.' 
  },
  { 
    id: 105, 
    difficulty: 'Medium', 
    query: 'SELECT dept, COUNT(*) FROM Staff GROUP BY dept HAVING COUNT(*) > 10', 
    question: 'Why is HAVING used instead of WHERE here?', 
    options: ['HAVING is faster', 'WHERE cannot be used with aggregate functions', 'HAVING sorts the data', 'They are interchangeable'], 
    answer: 'WHERE cannot be used with aggregate functions', 
    explanation: 'The WHERE keyword cannot be used with aggregate functions (like COUNT). HAVING was added to SQL for this purpose.' 
  },
  {
    id: 106,
    difficulty: 'Medium',
    query: 'SELECT * FROM Customers LEFT JOIN Orders ON Customers.id = Orders.cust_id',
    question: 'What is the key difference between LEFT JOIN and INNER JOIN?',
    options: ['LEFT JOIN returns all rows from the left table even if no match', 'LEFT JOIN is faster', 'LEFT JOIN only returns matching rows', 'LEFT JOIN deletes non-matching rows'],
    answer: 'LEFT JOIN returns all rows from the left table even if no match',
    explanation: 'LEFT JOIN returns all records from the left table (Customers), and the matched records from the right table (Orders).'
  },
  {
    id: 107,
    difficulty: 'Medium',
    query: 'SELECT * FROM Orders RIGHT JOIN Shippers ON Orders.shipper_id = Shippers.id',
    question: 'Which table will have ALL its rows returned?',
    options: ['Orders (Left)', 'Shippers (Right)', 'Both', 'Neither'],
    answer: 'Shippers (Right)',
    explanation: 'RIGHT JOIN returns all records from the right table (Shippers), and the matched records from the left table (Orders).'
  },
  {
    id: 108,
    difficulty: 'Medium',
    query: 'SELECT A.name AS Employee, B.name AS Manager FROM Employees A, Employees B WHERE A.manager_id = B.id',
    question: 'What kind of join is this?',
    options: ['Outer Join', 'Self Join', 'Cross Join', 'Natural Join'],
    answer: 'Self Join',
    explanation: 'A Self Join is a regular join, but the table is joined with itself.'
  },
  {
    id: 109,
    difficulty: 'Medium',
    query: 'SELECT name FROM Products WHERE price > (SELECT AVG(price) FROM Products)',
    question: 'This query uses a Subquery. What does it return?',
    options: ['Products with the average price', 'Products costing more than the average', 'The average price itself', 'All products'],
    answer: 'Products costing more than the average',
    explanation: 'The inner query calculates the average price first, and the outer query filters products based on that value.'
  },
  {
    id: 110,
    difficulty: 'Medium',
    query: 'SELECT city FROM Customers UNION SELECT city FROM Suppliers',
    question: 'What does the UNION operator do?',
    options: ['Combines results and keeps duplicates', 'Combines results and removes duplicates', 'Joins the tables', 'Finds common cities only'],
    answer: 'Combines results and removes duplicates',
    explanation: 'The UNION operator is used to combine the result-set of two or more SELECT statements. It removes duplicates by default.'
  },
  {
    id: 111,
    difficulty: 'Medium',
    query: 'SELECT city FROM Customers UNION ALL SELECT city FROM Suppliers',
    question: 'How does UNION ALL differ from UNION?',
    options: ['It sorts the results', 'It allows duplicate values', 'It is slower', 'It removes NULLs'],
    answer: 'It allows duplicate values',
    explanation: 'UNION ALL combines results including duplicates, which can also make it faster than UNION.'
  },
  {
    id: 112,
    difficulty: 'Medium',
    query: 'SELECT * FROM Users WHERE email IS NOT NULL',
    question: 'What is the purpose of IS NOT NULL?',
    options: ['To find users without emails', 'To find users with any email address', 'To set the email to NULL', 'To delete users with emails'],
    answer: 'To find users with any email address',
    explanation: 'IS NOT NULL is used to test for non-empty values (it filters out NULLs).'
  },
  {
    id: 113,
    difficulty: 'Medium',
    query: 'SELECT COUNT(DISTINCT country) FROM Customers',
    question: 'What does this query count?',
    options: ['Total customers', 'Total countries', 'Number of unique countries listed', 'Customers with unique names'],
    answer: 'Number of unique countries listed',
    explanation: 'COUNT(DISTINCT column) returns the number of unique non-null values in that column.'
  },
  {
    id: 114,
    difficulty: 'Medium',
    query: 'SELECT * FROM Sales WHERE date BETWEEN "2023-01-01" AND "2023-12-31"',
    question: 'Is the end date "2023-12-31" included in the results?',
    options: ['No', 'Yes', 'Depends on the database', 'Only if time is 00:00:00'],
    answer: 'Yes',
    explanation: 'The BETWEEN operator is inclusive: begin and end values are included.'
  },
  {
    id: 115,
    difficulty: 'Medium',
    query: 'SELECT COALESCE(phone, email, "No Contact") FROM Users',
    question: 'What does COALESCE return?',
    options: ['The first non-null value', 'The last non-null value', 'All values combined', 'Only "No Contact"'],
    answer: 'The first non-null value',
    explanation: 'COALESCE returns the first non-null expression in the list.'
  },
  {
    id: 116,
    difficulty: 'Medium',
    query: 'SELECT name, CASE WHEN age >= 18 THEN "Adult" ELSE "Minor" END AS Status FROM Users',
    question: 'What is the CASE statement used for?',
    options: ['Looping', 'Conditional logic (If-Then-Else)', 'Grouping data', 'Sorting data'],
    answer: 'Conditional logic (If-Then-Else)',
    explanation: 'The CASE expression goes through conditions and returns a value when the first condition is met.'
  },
  {
    id: 117,
    difficulty: 'Medium',
    query: 'CREATE VIEW ActiveUsers AS SELECT * FROM Users WHERE active = 1',
    question: 'What is a VIEW?',
    options: ['A physical table', 'A virtual table based on a query', 'A temporary table', 'A backup'],
    answer: 'A virtual table based on a query',
    explanation: 'A VIEW is a virtual table based on the result-set of an SQL statement. It does not store data itself.'
  },
  {
    id: 118,
    difficulty: 'Medium',
    query: 'SELECT * FROM Students ORDER BY grade DESC, name ASC',
    question: 'How is the sorting applied here?',
    options: ['By name only', 'By grade only', 'First by grade (High-Low), then name (A-Z)', 'First by grade (Low-High), then name (Z-A)'],
    answer: 'First by grade (High-Low), then name (A-Z)',
    explanation: 'SQL sorts by the first column specified, then by the second column if the first column has ties.'
  },
  {
    id: 119,
    difficulty: 'Medium',
    query: 'SELECT TRUNCATE(123.4567, 2)',
    question: 'What is the result of this function?',
    options: ['123.46', '123.45', '123', '124'],
    answer: '123.45',
    explanation: 'TRUNCATE() truncates a number to the specified number of decimal places without rounding.'
  },
  {
    id: 120,
    difficulty: 'Medium',
    query: 'SELECT dept_id, SUM(salary) FROM Employees GROUP BY dept_id HAVING SUM(salary) > 500000',
    question: 'Can you use the WHERE clause instead of HAVING here?',
    options: ['Yes', 'No, WHERE filters rows before grouping', 'Yes, but it is slower', 'No, WHERE does not exist'],
    answer: 'No, WHERE filters rows before grouping',
    explanation: 'WHERE filters individual rows. HAVING filters groups created by GROUP BY.'
  },
  {
    id: 121,
    difficulty: 'Medium',
    query: 'SELECT CONCAT_WS("-", "2023", "01", "01")',
    question: 'What does CONCAT_WS do?',
    options: ['Adds numbers', 'Concatenates With Separator', 'Concatenates With Space', 'Splits string'],
    answer: 'Concatenates With Separator',
    explanation: 'CONCAT_WS stands for Concatenate With Separator. The first argument is the separator.'
  },
  {
    id: 122,
    difficulty: 'Medium',
    query: 'SELECT * FROM Products WHERE category = "Electronics" LIMIT 5 OFFSET 10',
    question: 'Which records are retrieved?',
    options: ['Records 1-5', 'Records 11-15', 'Records 6-10', 'Records 10-15'],
    answer: 'Records 11-15',
    explanation: 'OFFSET 10 skips the first 10, then LIMIT 5 takes the next 5 (11th to 15th).'
  },
  {
    id: 123,
    difficulty: 'Medium',
    query: 'SELECT name FROM Users WHERE EXISTS (SELECT 1 FROM Orders WHERE user_id = Users.id)',
    question: 'What does the EXISTS operator check?',
    options: ['If a subquery returns any rows', 'If a value is NULL', 'If a table exists', 'If a user is active'],
    answer: 'If a subquery returns any rows',
    explanation: 'EXISTS returns TRUE if the subquery returns one or more records.'
  },
  {
    id: 124,
    difficulty: 'Medium',
    query: 'SELECT CAST("123" AS UNSIGNED)',
    question: 'What does CAST do?',
    options: ['Converts data type', 'Casts a shadow', 'Converts to string only', 'Rounds numbers'],
    answer: 'Converts data type',
    explanation: 'CAST() function converts a value (of any type) into a specified datatype.'
  },
  {
    id: 125,
    difficulty: 'Medium',
    query: 'ALTER TABLE Users ADD COLUMN age INT',
    question: 'What does this statement do?',
    options: ['Adds a new row', 'Modifies an existing row', 'Adds a new column to the table structure', 'Deletes the table'],
    answer: 'Adds a new column to the table structure',
    explanation: 'ALTER TABLE is used to add, delete, or modify columns in an existing table.'
  },
  {
    id: 126,
    difficulty: 'Medium',
    query: 'DROP TABLE TempUsers',
    question: 'What happens to the data inside TempUsers?',
    options: ['It is archived', 'It is moved to recycle bin', 'It is permanently deleted', 'It is hidden'],
    answer: 'It is permanently deleted',
    explanation: 'DROP TABLE deletes the table and all of its data permanently.'
  },
  {
    id: 127,
    difficulty: 'Medium',
    query: 'TRUNCATE TABLE Logs',
    question: 'How is TRUNCATE different from DELETE without WHERE?',
    options: ['TRUNCATE is slower', 'TRUNCATE cannot be rolled back in some DBs and resets auto-increment', 'TRUNCATE deletes specific rows', 'They are identical'],
    answer: 'TRUNCATE cannot be rolled back in some DBs and resets auto-increment',
    explanation: 'TRUNCATE is a DDL command (faster, resets ID) while DELETE is DML.'
  },
  {
    id: 128,
    difficulty: 'Medium',
    query: 'SELECT IFNULL(commission, 0) FROM Sales',
    question: 'What does IFNULL return if commission is 500?',
    options: ['0', '500', 'NULL', 'Error'],
    answer: '500',
    explanation: 'IFNULL(expression, alt_value) returns the expression if not NULL, otherwise it returns the alternative value.'
  },
  {
    id: 129,
    difficulty: 'Medium',
    query: 'SELECT * FROM A CROSS JOIN B',
    question: 'If Table A has 10 rows and Table B has 5 rows, how many rows are returned?',
    options: ['15', '50', '5', '10'],
    answer: '50',
    explanation: 'CROSS JOIN returns the Cartesian product (10 * 5 = 50).'
  },
  {
    id: 130,
    difficulty: 'Medium',
    query: 'SELECT name FROM Users WHERE name LIKE "[a-c]%"',
    question: 'What does the [a-c] pattern match?',
    options: ['Names starting with a, b, or c', 'Names containing a, b, or c', 'Names ending with a, b, or c', 'Names with exactly 3 letters'],
    answer: 'Names starting with a, b, or c',
    explanation: 'Square brackets allow you to specify a set of characters to match.'
  },
  {
    id: 131,
    difficulty: 'Medium',
    query: 'SELECT DATEDIFF("2023-01-10", "2023-01-01")',
    question: 'What does DATEDIFF return?',
    options: ['The date "2023-01-09"', '9 (days)', '10 (days)', 'Error'],
    answer: '9 (days)',
    explanation: 'DATEDIFF() returns the number of days between two date values.'
  },
  {
    id: 132,
    difficulty: 'Medium',
    query: 'SELECT * FROM Users WHERE id = ANY (SELECT user_id FROM Orders)',
    question: 'What does the ANY operator denote?',
    options: ['True if ALL subquery values match', 'True if AT LEAST ONE subquery value matches', 'True if NO subquery values match', 'True if subquery is empty'],
    answer: 'True if AT LEAST ONE subquery value matches',
    explanation: 'ANY returns true if the comparison is true for any of the values in the subquery.'
  },
  {
    id: 133,
    difficulty: 'Medium',
    query: 'SELECT * FROM Users WHERE id = ALL (SELECT user_id FROM Orders)',
    question: 'What does the ALL operator denote?',
    options: ['True if AT LEAST ONE matches', 'True if ALL subquery values match', 'True if values are distinct', 'True if subquery returns 1 row'],
    answer: 'True if ALL subquery values match',
    explanation: 'ALL returns true only if the comparison is true for every value in the subquery.'
  },
  {
    id: 134,
    difficulty: 'Medium',
    query: 'UPDATE Users SET score = score + 10',
    question: 'Which rows are affected?',
    options: ['Only the first row', 'Only the last row', 'All rows in the table', 'No rows (missing WHERE)'],
    answer: 'All rows in the table',
    explanation: 'Without a WHERE clause, UPDATE applies to every record in the table.'
  },
  {
    id: 135,
    difficulty: 'Medium',
    query: 'SELECT EXTRACT(YEAR FROM "2023-05-15")',
    question: 'What is the result?',
    options: ['2023', '05', '15', '2023-05-15'],
    answer: '2023',
    explanation: 'EXTRACT() retrieves a specific part (Year, Month, Day) from a date.'
  },
  {
    id: 136,
    difficulty: 'Medium',
    query: 'SELECT REPLACE(name, "a", "o") FROM Users',
    question: 'If name is "Banana", what is the result?',
    options: ['Bonona', 'Banana', 'Bnana', 'Banano'],
    answer: 'Bonona',
    explanation: 'REPLACE() substitutes all occurrences of the substring "a" with "o".'
  },
  {
    id: 137,
    difficulty: 'Medium',
    query: 'SELECT REVERSE("SQL")',
    question: 'What does REVERSE() do?',
    options: ['Converts to Lowercase', 'Reverses the string characters', 'Swaps first and last letter', 'Deletes string'],
    answer: 'Reverses the string characters',
    explanation: 'REVERSE() reverses a string and returns the result (e.g., "LQS").'
  },
  {
    id: 138,
    difficulty: 'Medium',
    query: 'SELECT CEILING(AVG(salary)) FROM Emp',
    question: 'If average is 5000.1, what is returned?',
    options: ['5000', '5001', '5000.1', '5000.0'],
    answer: '5001',
    explanation: 'CEILING() rounds a number up to the nearest integer.'
  },
  {
    id: 139,
    difficulty: 'Medium',
    query: 'SELECT * FROM A INNER JOIN B ON 1=1',
    question: 'What does joining ON 1=1 produce?',
    options: ['Empty set', 'Inner Join based on IDs', 'Cartesian Product (Cross Join)', 'Error'],
    answer: 'Cartesian Product (Cross Join)',
    explanation: 'Since 1=1 is always true, every row in A matches every row in B.'
  },
  {
    id: 140,
    difficulty: 'Medium',
    query: 'SELECT NULLIF(25, 25)',
    question: 'What is the result?',
    options: ['25', '0', 'NULL', 'True'],
    answer: 'NULL',
    explanation: 'NULLIF(exp1, exp2) returns NULL if exp1 equals exp2; otherwise it returns exp1.'
  },
  {
    id: 141,
    difficulty: 'Medium',
    query: 'GRANT SELECT ON Users TO "John"',
    question: 'What is this command for?',
    options: ['Creating a user', 'Deleting a user', 'Giving read permission', 'Giving delete permission'],
    answer: 'Giving read permission',
    explanation: 'GRANT gives specific privileges (like SELECT) to users.'
  },
  {
    id: 142,
    difficulty: 'Medium',
    query: 'REVOKE INSERT ON Orders FROM "John"',
    question: 'What does this command do?',
    options: ['Bans John', 'Removes John\'s ability to add rows', 'Deletes John\'s rows', 'Allows John to insert'],
    answer: 'Removes John\'s ability to add rows',
    explanation: 'REVOKE takes away previously granted permissions.'
  },
  {
    id: 143,
    difficulty: 'Medium',
    query: 'SELECT * FROM Products WHERE name LIKE "[!a-e]%"',
    question: 'What does the ! inside brackets mean?',
    options: ['Match a-e', 'Not match characters in the range', 'Match ! symbol', 'Error'],
    answer: 'Not match characters in the range',
    explanation: 'In some SQL dialects (like Access/SQL Server), ! or ^ negates the character set.'
  },
  {
    id: 144,
    difficulty: 'Medium',
    query: 'SELECT DAYOFWEEK("2023-01-01")',
    question: 'What does this return?',
    options: ['The day name (Sunday)', 'A number representing the day (e.g., 1 for Sunday)', 'The date', 'The week number'],
    answer: 'A number representing the day (e.g., 1 for Sunday)',
    explanation: 'DAYOFWEEK returns the weekday index (1=Sunday, 2=Monday, etc., in ODBC standard).'
  },
  {
    id: 145,
    difficulty: 'Medium',
    query: 'SELECT * FROM Users LIMIT 0, 5',
    question: 'What is the syntax "0, 5" equivalent to?',
    options: ['LIMIT 0 OFFSET 5', 'LIMIT 5 OFFSET 0', 'LIMIT 5', 'No Limit'],
    answer: 'LIMIT 5 OFFSET 0',
    explanation: 'In MySQL syntax, LIMIT offset, count is used. 0, 5 means start at 0, take 5.'
  },
  {
    id: 146,
    difficulty: 'Medium',
    query: 'SELECT STDEV(score) FROM Exams',
    question: 'What is STDEV?',
    options: ['Standard Deviation', 'Standard Division', 'String Device', 'Static Development'],
    answer: 'Standard Deviation',
    explanation: 'STDEV() calculates the statistical standard deviation of a set of values.'
  },
  {
    id: 147,
    difficulty: 'Medium',
    query: 'SELECT USER()',
    question: 'What does this function return?',
    options: ['Current database name', 'Current logged-in user and host', 'List of all users', 'Admin password'],
    answer: 'Current logged-in user and host',
    explanation: 'USER() or CURRENT_USER() returns the user name and host name for the current session.'
  },
  {
    id: 148,
    difficulty: 'Medium',
    query: 'SELECT 15 DIV 2',
    question: 'What is the result of integer division DIV?',
    options: ['7.5', '7', '8', '1'],
    answer: '7',
    explanation: 'DIV performs integer division, discarding the remainder.'
  },
  {
    id: 149,
    difficulty: 'Medium',
    query: 'SELECT POWER(4, 0.5)',
    question: 'What calculation is this?',
    options: ['4 to the power of 0.5 (Square Root)', '4 divided by 0.5', '4 times 0.5', 'Error'],
    answer: '4 to the power of 0.5 (Square Root)',
    explanation: 'Raising to the power of 0.5 is mathematically equivalent to a square root.'
  },
  {
    id: 150,
    difficulty: 'Medium',
    query: 'SELECT LTRIM("   SQL")',
    question: 'What does LTRIM remove?',
    options: ['All spaces', 'Trailing spaces (Right)', 'Leading spaces (Left)', 'Middle spaces'],
    answer: 'Leading spaces (Left)',
    explanation: 'LTRIM() removes whitespace from the Left side of a string.'
  },

  // =================================================================
  // HARD QUESTIONS (ID 201-250)
  // Focus: Window Functions, CTEs, Advanced Joins, Optimization, Theory
  // =================================================================
  { 
    id: 201, 
    difficulty: 'Hard', 
    query: 'SELECT * FROM Emp e1 WHERE salary > (SELECT AVG(salary) FROM Emp e2 WHERE e2.dept = e1.dept)', 
    question: 'This is a Correlated Subquery. What logic does it perform?', 
    options: ['Finds employees earning above the company average', 'Finds employees earning above their own department\'s average', 'Finds the highest paid employee', 'Calculates total salary'], 
    answer: 'Finds employees earning above their own department\'s average', 
    explanation: 'The inner query references the outer query (e2.dept = e1.dept), so it calculates the average for each specific department row-by-row.' 
  },
  { 
    id: 202, 
    difficulty: 'Hard', 
    query: 'SELECT name, RANK() OVER (ORDER BY score DESC) FROM Players', 
    question: 'What does the RANK() window function do if two players have the same score?', 
    options: ['They get different ranks randomly', 'They get the same rank, and the next rank is skipped', 'They get the same rank, and the next rank is consecutive', 'It throws an error'], 
    answer: 'They get the same rank, and the next rank is skipped', 
    explanation: 'RANK() gives tied rows the same rank, but leaves gaps in the numbering (e.g., 1, 2, 2, 4). DENSE_RANK() would be 1, 2, 2, 3.' 
  },
  { 
    id: 203, 
    difficulty: 'Hard', 
    query: 'SELECT * FROM A LEFT JOIN B ON A.id = B.id WHERE B.id IS NULL', 
    question: 'This pattern is known as an Anti-Join. What does it retrieve?', 
    options: ['Rows common to both tables', 'Rows in A that are NOT in B', 'Rows in B that are NOT in A', 'All rows from both tables'], 
    answer: 'Rows in A that are NOT in B', 
    explanation: 'A LEFT JOIN includes all rows from A. Filtering for B.id IS NULL removes the matching rows, leaving only those unique to A.' 
  },
  { 
    id: 204, 
    difficulty: 'Hard', 
    query: 'SELECT COALESCE(phone, email, "No Contact") FROM Users', 
    question: 'What is the specific behavior of COALESCE here?', 
    options: ['It combines phone and email', 'It returns the first non-null value', 'It returns the last non-null value', 'It returns "No Contact" only if both are present'], 
    answer: 'It returns the first non-null value', 
    explanation: 'COALESCE returns the first non-null expression in the list. If phone is null, it checks email. If both are null, it returns "No Contact".' 
  },
  { 
    id: 205, 
    difficulty: 'Hard', 
    query: 'SELECT * FROM Logs WHERE date > NOW() - INTERVAL 7 DAY', 
    question: 'This query uses date arithmetic. What time frame does it cover?', 
    options: ['Logs from exactly 7 days ago', 'Logs from the last 7 days', 'Logs older than 7 days', 'Logs from next week'], 
    answer: 'Logs from the last 7 days', 
    explanation: 'NOW() - INTERVAL 7 DAY calculates the timestamp 7 days ago. The > operator selects everything that happened after that point.' 
  },
  {
    id: 206,
    difficulty: 'Hard',
    query: 'WITH RECURSIVE Hierarchy AS (...) SELECT * FROM Hierarchy',
    question: 'What is a primary use case for a Recursive CTE?',
    options: ['Calculating simple averages', 'Traversing hierarchical data (like org charts)', 'Joining two flat tables', 'Creating a temporary view'],
    answer: 'Traversing hierarchical data (like org charts)',
    explanation: 'Recursive CTEs are designed to iterate over relational data, making them ideal for parent-child hierarchies.'
  },
  {
    id: 207,
    difficulty: 'Hard',
    query: 'SELECT * FROM Emp ORDER BY salary DESC LIMIT 1 OFFSET 2',
    question: 'Which employee does this query return?',
    options: ['The highest paid', 'The second highest paid', 'The third highest paid', 'The lowest paid'],
    answer: 'The third highest paid',
    explanation: 'OFFSET 2 skips the first two rows (1st and 2nd highest), so LIMIT 1 picks the 3rd.'
  },
  {
    id: 208,
    difficulty: 'Hard',
    query: 'SELECT dept, LISTAGG(name, ", ") WITHIN GROUP (ORDER BY name) FROM Emp GROUP BY dept',
    question: 'What does LISTAGG (or STRING_AGG) do?',
    options: ['Counts the names', 'Concatenates values into a single string per group', 'Creates a list object', 'Separates names into rows'],
    answer: 'Concatenates values into a single string per group',
    explanation: 'LISTAGG aggregates strings from multiple rows into one string, separated by a delimiter.'
  },
  {
    id: 209,
    difficulty: 'Hard',
    query: 'SELECT * FROM Sales PIVOT (SUM(amount) FOR month IN ("Jan", "Feb"))',
    question: 'What is the purpose of the PIVOT operator?',
    options: ['To rotate rows into columns', 'To rotate columns into rows', 'To join tables', 'To sort data'],
    answer: 'To rotate rows into columns',
    explanation: 'PIVOT transforms unique data values from one column into multiple columns in the output.'
  },
  {
    id: 210,
    difficulty: 'Hard',
    query: 'EXPLAIN SELECT * FROM HugeTable WHERE col = "val"',
    question: 'What is the EXPLAIN command used for?',
    options: ['To run the query faster', 'To analyze the execution plan and index usage', 'To describe the table structure', 'To export data'],
    answer: 'To analyze the execution plan and index usage',
    explanation: 'EXPLAIN provides details on how the database engine executes a query, helping with optimization.'
  },
  {
    id: 211,
    difficulty: 'Hard',
    query: 'CREATE INDEX idx_name ON Users(name)',
    question: 'How does an Index improve performance?',
    options: ['It sorts the physical data', 'It creates a lookup structure (B-Tree) to find rows faster', 'It compresses the data', 'It deletes duplicates'],
    answer: 'It creates a lookup structure (B-Tree) to find rows faster',
    explanation: 'Indexes allow the database to locate data without scanning the entire table (Full Table Scan).'
  },
  {
    id: 212,
    difficulty: 'Hard',
    query: 'SELECT * FROM Emp WHERE salary > ALL (SELECT salary FROM Mgr)',
    question: 'What does the ALL operator signify here?',
    options: ['Greater than the average manager salary', 'Greater than the lowest manager salary', 'Greater than the highest manager salary', 'Greater than total manager salary'],
    answer: 'Greater than the highest manager salary',
    explanation: '> ALL means the value must be greater than every single value returned by the subquery.'
  },
  {
    id: 213,
    difficulty: 'Hard',
    query: 'SELECT * FROM Emp WHERE salary > ANY (SELECT salary FROM Mgr)',
    question: 'What does the ANY (or SOME) operator signify?',
    options: ['Greater than the highest manager salary', 'Greater than the lowest manager salary', 'Greater than all manager salaries', 'Equal to a manager salary'],
    answer: 'Greater than the lowest manager salary',
    explanation: '> ANY means the value must be greater than at least one value returned by the subquery.'
  },
  {
    id: 214,
    difficulty: 'Hard',
    query: 'MERGE INTO Target T USING Source S ON (T.id = S.id)...',
    question: 'What operation does MERGE typically perform?',
    options: ['Only Inserts', 'Only Updates', 'Upsert (Insert or Update based on match)', 'Deletes table'],
    answer: 'Upsert (Insert or Update based on match)',
    explanation: 'MERGE allows you to perform INSERT, UPDATE, or DELETE operations in a single statement based on a condition.'
  },
  {
    id: 215,
    difficulty: 'Hard',
    query: 'SELECT NTILE(4) OVER (ORDER BY score) FROM Exams',
    question: 'What does NTILE(4) do to the result set?',
    options: ['Returns the top 4 rows', 'Multiplies score by 4', 'Divides rows into 4 equal groups (Quartiles)', 'Returns the 4th row'],
    answer: 'Divides rows into 4 equal groups (Quartiles)',
    explanation: 'NTILE(n) divides the ordered result set into n buckets as equally as possible.'
  },
  {
    id: 216,
    difficulty: 'Hard',
    query: 'SELECT LAG(salary, 1) OVER (ORDER BY date) FROM Payroll',
    question: 'What does the LAG function access?',
    options: ['The next row\'s value', 'The previous row\'s value', 'The first row\'s value', 'The last row\'s value'],
    answer: 'The previous row\'s value',
    explanation: 'LAG() provides access to a row at a given physical offset prior to the current row.'
  },
  {
    id: 217,
    difficulty: 'Hard',
    query: 'SELECT LEAD(salary, 1) OVER (ORDER BY date) FROM Payroll',
    question: 'What does the LEAD function access?',
    options: ['The next row\'s value', 'The previous row\'s value', 'The average value', 'The current value'],
    answer: 'The next row\'s value',
    explanation: 'LEAD() provides access to a row at a given physical offset following the current row.'
  },
  {
    id: 218,
    difficulty: 'Hard',
    query: 'SET TRANSACTION ISOLATION LEVEL SERIALIZABLE',
    question: 'What does the SERIALIZABLE isolation level guarantee?',
    options: ['Fastest performance', 'No dirty reads', 'Highest strictness (prevents Phantom Reads)', 'No locking'],
    answer: 'Highest strictness (prevents Phantom Reads)',
    explanation: 'Serializable is the highest isolation level, ensuring transactions are completely isolated from one another.'
  },
  {
    id: 219,
    difficulty: 'Hard',
    query: 'SELECT * FROM T1 NATURAL JOIN T2',
    question: 'How does a NATURAL JOIN determine the join condition?',
    options: ['By Primary Keys', 'By Foreign Keys', 'By columns with the same name', 'It produces a Cartesian product'],
    answer: 'By columns with the same name',
    explanation: 'NATURAL JOIN creates an implicit join clause for all columns with the same name in the two tables.'
  },
  {
    id: 220,
    difficulty: 'Hard',
    query: 'DELETE FROM Users WHERE id NOT IN (SELECT MIN(id) FROM Users GROUP BY email)',
    question: 'What is the purpose of this query?',
    options: ['To delete all users', 'To delete users with no email', 'To delete duplicate records, keeping the oldest', 'To delete the oldest users'],
    answer: 'To delete duplicate records, keeping the oldest',
    explanation: 'It keeps the minimum ID (oldest) for each email and deletes the rest.'
  },
  {
    id: 221,
    difficulty: 'Hard',
    query: 'SELECT JSON_EXTRACT(data, "$.key") FROM JsonTable',
    question: 'What is this query interacting with?',
    options: ['XML data', 'JSON data stored in a column', 'Binary data', 'External file'],
    answer: 'JSON data stored in a column',
    explanation: 'Modern SQL databases often support JSON types and functions to query keys within JSON strings.'
  },
  {
    id: 222,
    difficulty: 'Hard',
    query: 'SELECT * FROM Orders WHERE order_date > CURRENT_DATE - 1',
    question: 'Depending on the DB, what might "CURRENT_DATE - 1" mean?',
    options: ['Yesterday', 'One hour ago', 'One year ago', 'Invalid syntax'],
    answer: 'Yesterday',
    explanation: 'In many SQL dialects (like Oracle/Postgres), subtracting an integer from a date subtracts days.'
  },
  {
    id: 223,
    difficulty: 'Hard',
    query: 'SELECT ROW_NUMBER() OVER (PARTITION BY dept ORDER BY salary DESC) FROM Emp',
    question: 'What is the numbering scope here?',
    options: ['Global (1 to Total Rows)', 'Resets for each Department', 'Resets for each Salary', 'Random'],
    answer: 'Resets for each Department',
    explanation: 'PARTITION BY dept causes the row number counter to reset to 1 for each new department group.'
  },
  {
    id: 224,
    difficulty: 'Hard',
    query: 'ROLLBACK TO SAVEPOINT sv1',
    question: 'What happens to changes made BEFORE "sv1"?',
    options: ['They are rolled back', 'They are saved/preserved', 'They are deleted', 'The connection closes'],
    answer: 'They are saved/preserved',
    explanation: 'Rolling back to a savepoint only undoes transactions that occurred AFTER that savepoint was created.'
  },
  {
    id: 225,
    difficulty: 'Hard',
    query: 'SELECT * FROM Emp WHERE salary > (SELECT AVG(salary) FROM Emp)',
    question: 'Is this subquery Correlated or Uncorrelated?',
    options: ['Correlated', 'Uncorrelated', 'Recursive', 'Invalid'],
    answer: 'Uncorrelated',
    explanation: 'The inner query (AVG salary) can run independently once and does not reference the outer query rows.'
  },
  {
    id: 226,
    difficulty: 'Hard',
    query: 'SELECT NULL = NULL',
    question: 'What is the result of this expression?',
    options: ['TRUE', 'FALSE', 'NULL', 'Error'],
    answer: 'NULL',
    explanation: 'In SQL, NULL is unknown. Unknown equals Unknown is still Unknown (NULL). Use IS NULL to check.'
  },
  {
    id: 227,
    difficulty: 'Hard',
    query: 'SELECT * FROM T1 WHERE (col1, col2) IN (SELECT col1, col2 FROM T2)',
    question: 'What feature is being used here?',
    options: ['Row Constructor / Tuple Comparison', 'Cross Join', 'Union', 'Natural Join'],
    answer: 'Row Constructor / Tuple Comparison',
    explanation: 'SQL allows comparing a tuple (row of values) against a set of tuples.'
  },
  {
    id: 228,
    difficulty: 'Hard',
    query: 'CREATE TRIGGER trg_audit AFTER UPDATE ON Users...',
    question: 'When does this trigger fire?',
    options: ['Before the update happens', 'After the update is committed', 'After the update statement executes', 'Instead of the update'],
    answer: 'After the update statement executes',
    explanation: 'AFTER triggers run once the DML action is complete but before the transaction is committed.'
  },
  {
    id: 229,
    difficulty: 'Hard',
    query: 'SELECT CAST(salary AS CHAR) FROM Emp',
    question: 'Why would you cast a number to a string?',
    options: ['To perform math', 'To concatenate with other text', 'To save storage', 'To sort numerically'],
    answer: 'To concatenate with other text',
    explanation: 'You often cast to string to combine numerical data with text labels.'
  },
  {
    id: 230,
    difficulty: 'Hard',
    query: 'SELECT * FROM Orders WHERE id LIKE "10%"',
    question: 'Why is using LIKE on a numeric ID column generally bad practice?',
    options: ['It throws an error', 'It prevents Index usage (often) and requires implicit casting', 'It is faster', 'It is syntax error'],
    answer: 'It prevents Index usage (often) and requires implicit casting',
    explanation: 'LIKE is for strings. Using it on numbers forces the DB to convert numbers to strings, hurting performance.'
  },
  {
    id: 231,
    difficulty: 'Hard',
    query: 'SELECT * FROM Emp ORDER BY 2',
    question: 'What does "ORDER BY 2" mean?',
    options: ['Sort by the 2nd column in the table', 'Sort by the 2nd column in the SELECT list', 'Sort by 2 columns', 'Sort by ID 2'],
    answer: 'Sort by the 2nd column in the SELECT list',
    explanation: 'Ordinal numbers in ORDER BY refer to the position of the column in the SELECT clause.'
  },
  {
    id: 232,
    difficulty: 'Hard',
    query: 'SELECT STDEV(salary) FROM Emp',
    question: 'What statistical metric does STDEV calculate?',
    options: ['Standard Deviation', 'Standard Variance', 'Student Distribution', 'Statistical Depth'],
    answer: 'Standard Deviation',
    explanation: 'STDEV calculates how spread out the values are from the mean.'
  },
  {
    id: 233,
    difficulty: 'Hard',
    query: 'SELECT * FROM Emp WHERE salary BETWEEN 50000 AND 60000',
    question: 'Is this equivalent to "salary >= 50000 AND salary <= 60000"?',
    options: ['Yes, exactly', 'No, BETWEEN is exclusive', 'No, BETWEEN handles NULLs differently', 'Depends on DB'],
    answer: 'Yes, exactly',
    explanation: 'The standard behavior of BETWEEN is inclusive, equivalent to >= AND <=.'
  },
  {
    id: 234,
    difficulty: 'Hard',
    query: 'SELECT AVG(DISTINCT salary) FROM Emp',
    question: 'How is this different from AVG(salary)?',
    options: ['It is the same', 'It removes duplicates before averaging', 'It removes NULLs only', 'It sorts before averaging'],
    answer: 'It removes duplicates before averaging',
    explanation: 'AVG(DISTINCT) calculates the average of unique salary values only.'
  },
  {
    id: 235,
    difficulty: 'Hard',
    query: 'SELECT * FROM Emp WHERE dept_id NOT IN (SELECT id FROM Dept WHERE active = 0)',
    question: 'What is a major risk with NOT IN if the subquery returns a NULL?',
    options: ['No risk', 'The entire query returns 0 rows (Empty Set)', 'It ignores NULL', 'It returns an error'],
    answer: 'The entire query returns 0 rows (Empty Set)',
    explanation: 'If a subquery returns NULL, "NOT IN" cannot determine truth, resulting in Unknown for all rows, returning nothing.'
  },
  {
    id: 236,
    difficulty: 'Hard',
    query: 'SELECT * FROM Emp WHERE ROWNUM <= 5',
    question: 'ROWNUM is specific to which database?',
    options: ['MySQL', 'PostgreSQL', 'Oracle', 'SQL Server'],
    answer: 'Oracle',
    explanation: 'Oracle uses ROWNUM to limit rows. MySQL uses LIMIT, SQL Server uses TOP.'
  },
  {
    id: 237,
    difficulty: 'Hard',
    query: 'SELECT * FROM Emp LIMIT 5, 10',
    question: 'In MySQL syntax, what does "LIMIT 5, 10" mean?',
    options: ['Skip 5, Take 10', 'Take 5, Skip 10', 'Rows 5 to 10', 'Limit 5 or 10'],
    answer: 'Skip 5, Take 10',
    explanation: 'The first number is the Offset, the second is the Count.'
  },
  {
    id: 238,
    difficulty: 'Hard',
    query: 'SELECT user, count(*) FROM Logs GROUP BY user HAVING count(*) > 5',
    question: 'What is the logical order of execution?',
    options: ['SELECT, FROM, GROUP BY, HAVING', 'FROM, GROUP BY, HAVING, SELECT', 'FROM, WHERE, SELECT, HAVING', 'SELECT, HAVING, GROUP BY'],
    answer: 'FROM, GROUP BY, HAVING, SELECT',
    explanation: 'The database first gets data (FROM), groups it, filters the groups (HAVING), and finally selects columns.'
  },
  {
    id: 239,
    difficulty: 'Hard',
    query: 'SELECT * FROM A FULL OUTER JOIN B ON A.id = B.id',
    question: 'What rows does a FULL OUTER JOIN return?',
    options: ['Matching rows only', 'Rows from A only', 'Rows from B only', 'All rows from both, matching where possible, NULLs where not'],
    answer: 'All rows from both, matching where possible, NULLs where not',
    explanation: 'Full Outer Join combines the results of both Left and Right joins.'
  },
  {
    id: 240,
    difficulty: 'Hard',
    query: 'SELECT VARIANCE(score) FROM Exams',
    question: 'What is the relationship between VARIANCE and STDEV?',
    options: ['Variance is the square root of STDEV', 'STDEV is the square root of Variance', 'They are the same', 'Unrelated'],
    answer: 'STDEV is the square root of Variance',
    explanation: 'Standard Deviation is the square root of Variance.'
  },
  {
    id: 241,
    difficulty: 'Hard',
    query: 'SELECT CUME_DIST() OVER (ORDER BY score) FROM Exams',
    question: 'What does Cumulative Distribution calculate?',
    options: ['The sum of scores', 'The relative rank (percentile) of a row', 'The mode', 'The median'],
    answer: 'The relative rank (percentile) of a row',
    explanation: 'CUME_DIST() calculates the fraction of rows with a value less than or equal to the current row.'
  },
  {
    id: 242,
    difficulty: 'Hard',
    query: 'SELECT * FROM Emp WHERE name REGEXP "^A"',
    question: 'What does REGEXP "^A" match?',
    options: ['Names containing A', 'Names ending with A', 'Names starting with A', 'Names with A at index 1'],
    answer: 'Names starting with A',
    explanation: 'In Regular Expressions, the caret (^) symbol denotes the start of a string.'
  },
  {
    id: 243,
    difficulty: 'Hard',
    query: 'SELECT IF(score > 50, "Pass", "Fail") FROM Exams',
    question: 'Which database uses the IF() function like this?',
    options: ['Oracle', 'SQL Server', 'MySQL', 'PostgreSQL'],
    answer: 'MySQL',
    explanation: 'MySQL supports the IF(condition, true, false) function. Others use CASE WHEN.'
  },
  {
    id: 244,
    difficulty: 'Hard',
    query: 'SELECT * FROM Emp WHERE salary = (SELECT MIN(salary) FROM (SELECT salary FROM Emp ORDER BY salary DESC LIMIT 3) AS Top3)',
    question: 'What is this complicated query trying to find?',
    options: ['The lowest salary', 'The 3rd highest salary', 'The average salary', 'Random salary'],
    answer: 'The 3rd highest salary',
    explanation: 'It selects the top 3 salaries, then picks the minimum of those, effectively getting the 3rd highest.'
  },
  {
    id: 245,
    difficulty: 'Hard',
    query: 'ALTER TABLE Users DROP PRIMARY KEY',
    question: 'Can a table exist without a Primary Key?',
    options: ['No, never', 'Yes, a heap table', 'Only temporary tables', 'Only views'],
    answer: 'Yes, a heap table',
    explanation: 'While bad practice for relational integrity, tables can technically exist without a PK (often called Heaps).'
  },
  {
    id: 246,
    difficulty: 'Hard',
    query: 'SELECT USER_ID()',
    question: 'Is this a standard SQL function?',
    options: ['Yes', 'No, syntax varies by vendor', 'Only in SQL-92', 'Only in NoSQL'],
    answer: 'No, syntax varies by vendor',
    explanation: 'Standard SQL doesn\'t define USER_ID(). Oracle uses UID, SQL Server uses SUSER_ID(), etc.'
  },
  {
    id: 247,
    difficulty: 'Hard',
    query: 'CHECKPOINT',
    question: 'What does the CHECKPOINT command do?',
    options: ['Saves game', 'Forces dirty pages from memory to disk', 'Creates a backup', 'Validates syntax'],
    answer: 'Forces dirty pages from memory to disk',
    explanation: 'A checkpoint writes all modified pages (dirty pages) from the buffer cache to the physical disk.'
  },
  {
    id: 248,
    difficulty: 'Hard',
    query: 'SELECT * FROM Emp WHERE 1=0',
    question: 'What is the utility of this query?',
    options: ['It returns all rows', 'It creates an error', 'It returns column structure without data', 'It deletes the table'],
    answer: 'It returns column structure without data',
    explanation: 'Since 1=0 is false, no rows are returned, but the metadata (columns/types) is returned. Useful for copying table structures.'
  },
  {
    id: 249,
    difficulty: 'Hard',
    query: 'SELECT REPEAT("SQL", 3)',
    question: 'What is the result?',
    options: ['SQL3', 'SQLSQLSQL', 'SQL SQL SQL', 'Error'],
    answer: 'SQLSQLSQL',
    explanation: 'REPEAT() duplicates the string the specified number of times.'
  },
  {
    id: 250,
    difficulty: 'Hard',
    query: 'SELECT * FROM Emp FOR XML AUTO',
    question: 'What does the "FOR XML" clause do in SQL Server?',
    options: ['Exports table to Excel', 'Returns the result set as an XML string', 'Converts columns to text', 'Validates XML'],
    answer: 'Returns the result set as an XML string',
    explanation: 'It formats the query output as an XML document.'
  },
];